import { render, staticRenderFns } from "./FoodHub.vue?vue&type=template&id=67798006&scoped=true&"
import script from "./FoodHub.vue?vue&type=script&lang=js&"
export * from "./FoodHub.vue?vue&type=script&lang=js&"
import style0 from "./FoodHub.vue?vue&type=style&index=0&id=67798006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67798006",
  null
  
)

export default component.exports